// @flow
import produce from 'immer';

import * as actions from 'client/constants/actions';

type ShareResult = {
	description: string,
	total: number,
	selected: number,
	itemId?: string,
};

const initialState: ShareResult = {
	description: '',
	total: 0,
	selected: 0,
	itemId: '',
};

type Action = { type: typeof actions.ADD_SELECTED_ITEMS, payload: ShareResult };

export default function adminReducer(state: ShareResult = initialState, action: Action) {
	return produce<any>(state, (draft: ShareResult) => {
		switch (action.type) {
			case actions.SAVE_SHARE_RESULT_TEXT:
				return action.payload;

			default:
				return state;
		}
	});
}
